/**
 * Luma Group
 *
 * @author Robuust
 * @author Rutger Bakker <rutger@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';

/**
 * Popup controller.
 */
export default class extends Controller {
  /**
   * @return {Array}
   */
  static classes = ['hidden'];

  /**
   * @return {Object}
   */
  static values = {
    storageKey: {
      type: String,
      default: 'alert-popup-hidden',
    },
  };

  /**
   * Connect popup.
   */
  connect() {
    this.element.classList.toggle(this.hiddenClass, sessionStorage.getItem(this.storageKeyValue) === '1');
  }

  /**
   * Close popup.
   */
  close() {
    sessionStorage.setItem(this.storageKeyValue, '1');
    this.element.classList.add(this.hiddenClass);
  }
}
